import { render, staticRenderFns } from "./XiangMu2.vue?vue&type=template&id=cff042b0&scoped=true"
import script from "./XiangMu2.vue?vue&type=script&lang=js"
export * from "./XiangMu2.vue?vue&type=script&lang=js"
import style0 from "./XiangMu2.vue?vue&type=style&index=0&id=cff042b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff042b0",
  null
  
)

export default component.exports